import PreviewDetailImg from 'assets/images/feature-slots/preview_detail.png';
import PreviewListImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY, getRouteName } from './common';

const MODULE_NAME = 'Contract Purchase Order';

const routes = [
	{
		matchRegex: '/ContractPurchaseOrder',
		name: getRouteName(MODULE_NAME, 'All Contract PO'),
		slots: [SLOT_KEY.SLOT_V_SECTION, SLOT_KEY.SLOT_V_TABLE_COLUMN, SLOT_KEY.SLOT_SCRIPTS],
		image: PreviewListImg,
		parentKeys: {
			[SLOT_KEY.SLOT_V_SECTION]: [
				{ key: 'page-title', label: 'Page Title' },
				{ key: 'page-action', label: 'Page Action' }
			],
			[SLOT_KEY.SLOT_V_TABLE_COLUMN]: [{ key: 'contract-purchase-order-table', label: 'Contract Purchase Order Table' }]
		},
		options: {
			[SLOT_KEY.SLOT_SCRIPTS]: [
				{ key: 'MARKETPLACE_EVENT_TAB_CHANGE', label: 'Before Tab Change' },
				{ key: 'MARKETPLACE_EVENT_TOGGLE_TABLE_SETTING', label: 'Before Toggle Table Setting' }
			]
		}
	},
	{
		matchRegex: '/ContractPurchaseOrder/Detail/:id',
		name: getRouteName(MODULE_NAME, 'Detail'),
		slots: [SLOT_KEY.SLOT_SECTION, SLOT_KEY.SLOT_V_SECTION, SLOT_KEY.SLOT_V_TABLE_COLUMN, SLOT_KEY.SLOT_V_FORM_SECTION],
		image: PreviewDetailImg,
		parentKeys: {
			[SLOT_KEY.SLOT_SECTION]: [
				{ key: 'page-title', label: 'Page Title' },
				{ key: 'page-action', label: 'Page Action' },
				{ key: 'tab-details-form-wrapper', label: 'Tab Details - Form Wrapper' },
				{ key: 'wrapper-section-outbound-email', label: 'Tab History Outbound Emails - Wrapper' }
			],
			[SLOT_KEY.SLOT_V_SECTION]: [{ key: 'tab-invoices-action', label: 'Tab Invoices - Action' }],
			[SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
				{ key: 'contract-po-items', label: 'Tab Items - Contract PO Items Table' },
				{ key: 'invoice-list', label: 'Tab Invoices - Invoice Table' }
			],
			[SLOT_KEY.SLOT_V_FORM_SECTION]: [{ key: 'notes-tab', label: 'Tab Note - Form Wrapper' }]
		}
	},
	{
		matchRegex: '/ContractPurchaseOrder/CreateInvoice',
		name: getRouteName(MODULE_NAME, 'Invoice/Credit - Create'),
		slots: [SLOT_KEY.SLOT_SECTION],
		image: PreviewDetailImg,
		parentKeys: {
			[SLOT_KEY.SLOT_SECTION]: [
				{ key: 'page-title', label: 'Page Title' },
				{ key: 'form-wrapper', label: 'Form Wrapper' },
				{ key: 'bottom-bar', label: 'Bottom Bar' }
			]
		}
	},
	{
		matchRegex: '/ContractPurchaseOrder/InvoiceDetail/:id',
		name: getRouteName(MODULE_NAME, 'Invoice/Credit - Detail'),
		slots: [SLOT_KEY.SLOT_SECTION, SLOT_KEY.SLOT_V_TABLE_COLUMN, SLOT_KEY.SLOT_SCRIPTS],
		image: PreviewDetailImg,
		parentKeys: {
			[SLOT_KEY.SLOT_SECTION]: [
				{ key: 'page-title', label: 'Page Title' },
				{ key: 'page-action', label: 'Page Action' },
				{ key: 'form-wrapper', label: 'Form Wrapper' }
			],
			[SLOT_KEY.SLOT_V_TABLE_COLUMN]: [{ key: 'invoice-line-list', label: 'Invoice Line List' }]
		},
		options: {
			[SLOT_KEY.SLOT_SCRIPTS]: [{ key: 'MARKETPLACE_EVENT_GET_COLUMN', label: 'Show data column in line invoice' }]
		}
	}
];

export default routes;
